import React from "react";
import { Trans, useTranslation } from "react-i18next";
import ErrorPage from "components/errors/ErrorPage";
import { Link } from "components/common";
import Routes from "routing/Routes";
const NotFoundPage = ({ displayPageLayout = true }) => {
  const { t } = useTranslation("pages");
  const description = /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("p", null, t("not_found.description")), /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement(Trans, { t, i18nKey: "not_found.back_hint", components: { mainPageLink: /* @__PURE__ */ React.createElement(Link, { to: Routes.WELCOME }) } })));
  return /* @__PURE__ */ React.createElement(ErrorPage, { title: t("not_found.title"), description, displayPageLayout });
};
export default NotFoundPage;
